import { Colors } from '@/common/colors/colors';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Loading from '@/common/components/Loading';
import McpConsentSuccess from './components/McpConsentSuccess';
import useMcpConsent from './hooks/useMcpConsent';
import { Description, Title, Wrapper } from './McpConsent.styles';

const BUTTON_STYLE = { fontSize: '14px', width: '300px' };

const McpConsent = () => {
	const {
		redirectHost,
		redirectUrl,
		isConnecting,
		handleConnect,
		handleCancel,
	} = useMcpConsent();

	if (redirectUrl) {
		return <McpConsentSuccess redirectUrl={redirectUrl} />;
	}

	return (
		<Wrapper>
			{isConnecting && <Loading />}
			<Title>Connect Claude to CRM</Title>
			<Description>
				{redirectHost || 'Claude'} wants read access to CRM reports with your
				account permissions.
			</Description>
			<SubmitButton
				buttonType='secondary'
				style={BUTTON_STYLE}
				color={Colors.darkBlue}
				text='CONNECT'
				onClick={handleConnect}
			/>
			<SubmitButton
				buttonType='secondary'
				style={BUTTON_STYLE}
				color={Colors.red}
				text='CANCEL'
				onClick={handleCancel}
			/>
		</Wrapper>
	);
};

export default McpConsent;
